import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

interface PageTitleProps {
    titleKey?: string;
    namespace?: string;
    dynamicTitle?: string;
    descriptionKey?: string;
    description?: string;
    image?: string;
    type?: 'website' | 'article';
}

const PageTitle: React.FC<PageTitleProps> = ({ 
    titleKey, 
    namespace = 'common', 
    dynamicTitle, 
    descriptionKey,
    description,
    image = '/og-image.png',
    type = 'website'
}) => {
    const { t } = useTranslation(namespace);

    const title = dynamicTitle || (titleKey ? t(titleKey) : '');
    const metaDescription = description || (descriptionKey ? t(descriptionKey) : '');
    const siteName = import.meta.env.VITE_PRODUCT_NAME || 'Etherworks LLM';
    const fullTitle = title ? `${title} | ${siteName}` : siteName;

    return (
        <Helmet>
            {/* Standard metadata */}
            <title>{fullTitle}</title>
            {metaDescription && <meta name="description" content={metaDescription} />}

            {/* Open Graph */}
            <meta property="og:title" content={fullTitle} />
            {metaDescription && <meta property="og:description" content={metaDescription} />}
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={siteName} />
            {image && <meta property="og:image" content={image} />}

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            {metaDescription && <meta name="twitter:description" content={metaDescription} />}
            {image && <meta name="twitter:image" content={image} />}
        </Helmet>
    );
};

export default PageTitle;
